import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable()
export class EcwidService {
  //  isEskyAdmin:boolean;
  private headerOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(private http: HttpClient) { }

  createShop(company, alias, token, storeId) {
    console.log("crealte shop" + alias, +" token " + token + " store id " + storeId)
    return this.http.post('api/ecwid/createShop?alias=' + alias + '&token=' + token + '&storeId=' + storeId, JSON.stringify(company), this.headerOptions)
  }

  getStoreInformation(code) {
    return this.http.post('api/ecwid/getStoreInformation?code=' + code, this.headerOptions).pipe(map((res: Response) => res));
  }
}
